import React from 'react';

export default function ConnectMeta() {
  const handleConnect = () => {
    window.open('/api/meta/connect', '_blank');
  };

  return (
    <section className="panel">
      <h2>Connect Meta</h2>
      <p>Authorize your Facebook Page and Instagram Business account.</p>
      <button className="primary" onClick={handleConnect}>Connect Meta</button>
    </section>
  );
}
